'use client';

import { useGlobalClientContext } from '../common/GlobalClientContext';
import logo from '../../assets/images/logocic.png';
import Image from 'next/image';
import TermsV2 from './TermsV2';

export default function Footer() {
  const {
    i18nHelper: { t }
  } = useGlobalClientContext();

  return (
    <footer className="bg-white  w-full z-20 start-0 border-t-[1px] border-solid border-gray-100 bottom-0">
      <div
        className={`max-w-screen-xl w-[1280px] flex h-[72px] flex-wrap items-center justify-between mx-auto p-s`}>
        <div>
          <TermsV2 />
        </div>
        <div className="flex flex-row items-center justify-between gap-[24px] w-fit">
          <span className="font-regular font-body text-sm leading-xl text-secondary">
            {t('home.footer.copyright', { year: new Date().getFullYear()})}
          </span>
          <div>
            <a
              href="/"
              className="flex items-center space-x-3 rtl:space-x-reverse w-[92px]">
              <Image src={logo} alt="Logo" className="h-[32px]" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
